//const serverURL = "http://localhost:8000/"
 const serverURL = "https://mixbus-server.onrender.com/"
export default serverURL;